import React, { useEffect, useState, useContext, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

type SidebarProps = React.PropsWithChildren<{}>;

export default function Sidebar({ children }: SidebarProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [student, setStudent] = useState<{ name: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const id = localStorage.getItem("id");

    fetch(`https://has-backend-c48d669d897f.herokuapp.com/getAdmin/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setStudent({ name: data.name });
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error en el fetch del estudiante:", error);
        setIsLoading(false);
      });
  }, []);

  const handleLogout = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    authContext?.logout();
    navigate("/");
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("");
    const token = localStorage.getItem("token");
    const id = localStorage.getItem("id");
    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/getAdmin/${id}/update-password`, {
        
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Error al actualizar la contraseña");
      setShowPopup(false);
      setRefreshTrigger((prev) => prev + 1);

    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div className="relative w-full">
      {!isSidebarOpen && (
        <div className="sm:hidden fixed top-4 left-4 z-50">
          <button onClick={() => setIsSidebarOpen(true)} className="bg-[#1c1c2e] text-white p-2 rounded-md">
            ☰
          </button>
        </div>
      )}

      {isSidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 sm:hidden z-30" onClick={() => setIsSidebarOpen(false)} />
      )}

      <div
        className={`fixed top-0 left-0 h-screen w-3/4 sm:w-full sm:relative sm:translate-x-0 z-40 transition-transform duration-300 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full sm:translate-x-0"
        }`}
      >
        <div className="h-screen w-full flex flex-col justify-between bg-[#A3C1D1]">
          <div className="grid grid-cols-2 mt-16">
            <button onClick={() => setShowPopup(true)}>
              <img src="/assets/User.png" alt="user icon" />
            </button>
            <div className="flex flex-col">
              {isLoading ? (
                <p className="text-gray-700">Cargando...</p>
              ) : error ? (
                <p className="text-red-500">{error}</p>
              ) : (
                <p>{student?.name}</p>
              )}
            </div>
          </div>

          {/* Responsive Popup */}
          {showPopup && (
            <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
              <div className="bg-[#d9d9d9] w-full max-w-md mx-4 p-6 rounded-lg shadow-xl relative">
                <button
                  className="absolute top-2 right-2 text-gray-700 text-lg font-bold"
                  onClick={() => setShowPopup(false)}
                >
                  ×
                </button>
                <form onSubmit={handleSubmit} className="w-full flex flex-col">
                  <label className="font-sourceSans mb-1">Contraseña</label>
                  <input
                    className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4"
                    type="text"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  {message && <p className="text-red-600 text-sm mb-2">{message}</p>}
                  <div className="w-full flex justify-center">
                    <button
                      className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-1/2 shadow-lg py-2 mt-4"
                      type="submit"
                    >
                      Cambiar Contraseña
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div className="flex flex-col w-full gap-5">{children}</div>

          <div className="flex w-full mb-12 items-center justify-center">
            <button
              onClick={handleLogout}
              className="bg-[#1c1c2e] text-white font-sourceSans rounded-lg h-[100%] w-[80%] py-2"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

